import React from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  Grid,
  IconButton,
  Link,
  Button,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  ArrowBack,
  OpenInNew,
  Assignment,
  Report,
  ChevronRight
} from '@mui/icons-material';

const ResourceLink = ({ title, description, icon, link }) => (
  <ListItemButton 
    component={Link}
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    sx={{ 
      py: 2,
      px: 2,
      '&:hover': {
        backgroundColor: 'rgba(53, 152, 183, 0.08)',
      }
    }}
  >
    <ListItemIcon sx={{ color: '#3598b7', minWidth: 40 }}>
      {icon}
    </ListItemIcon>
    <ListItemText 
      primary={title}
      secondary={description}
      primaryTypographyProps={{
        sx: { color: '#2e2e2e', fontWeight: 500 }
      }}
      secondaryTypographyProps={{
        sx: { color: 'rgba(46, 46, 46, 0.7)' }
      }}
    />
    <ChevronRight sx={{ color: '#3598b7' }} />
  </ListItemButton>
);

const OnLocation = () => {
  const navigate = useNavigate();

  const resources = [
    {
      title: 'DJI Inspire 2/3',
      description: 'Sjekkliste for Inspire 2/3 på lokasjon',
      icon: <Assignment />,
      link: 'https://form.jotform.com/213216801476048'
    },
    {
      title: 'Freefly Alta X',
      description: 'Sjekkliste for Alta X på lokasjon',
      icon: <Assignment />,
      link: 'https://form.jotform.com/213222698366360'
    },
    {
      title: 'Rapportering',
      description: 'Hendelsesrapport, avviksrapport, teknisk rapport eller forbedringsforslag',
      icon: <Report />,
      link: 'https://docs.google.com/forms/d/e/1FAIpQLScOTPfvbhgfkC7xr5a_XineI4BVQ6oMBywgEYLdfAcavU9w9Q/viewform?usp=sf_link'
    }
  ];

  return (
    <Box sx={{ 
      p: 3, 
      maxWidth: 1200, 
      margin: '0 auto',
      minHeight: '100vh'
    }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ color: '#2e2e2e', fontWeight: 600, mb: 1 }}>
          Pilot Ressurser
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton 
            onClick={() => navigate('/pilot')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" sx={{ color: '#3598b7', fontWeight: 600 }}>
            På Lokasjon
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card sx={{ 
            backgroundColor: '#ffffff', 
            borderRadius: 0,
            boxShadow: 'none',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
              <Typography variant="h6" sx={{ color: '#3598b7', fontWeight: 600 }}>
                Skjemaer
              </Typography>
            </Box>
            <List disablePadding>
              {resources.map((resource, index) => (
                <React.Fragment key={index}>
                  <ResourceLink {...resource} />
                  {index < resources.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OnLocation; 